// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_link-error_btn-primary__h0O42","error-fallback":"_link-error_error-fallback__3JKbi","logo":"_link-error_logo__3aeJ7","oops":"_link-error_oops__2_7D0"};